import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { cloneAndAddHeaders, csdtAuthApp } from './lib.interceptors';

export const KeplerSlapfiveInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    /** TLD for kepler-slapfive-api */
    const urlToMatch = environment.api.kepler.slapfive.url;
    /** list of API endpoints that do not require Authorization and should be skipped by this interceptor */
    const publicEndpoints = ['/getLeaderboard', '/v2/leaderboard'];

    const defaultHeaders = {
        'Content-Type': 'application/json',
        'X-API-Key': environment.api.kepler.slapfive.apiKey, // API Gateway authorization key (not Okta Bearer token)
    };

    if (urlToMatch && req.url.startsWith(urlToMatch)) {
        if (publicEndpoints.find((e) => req.url.includes(e))) {
            const clone = cloneAndAddHeaders(req, defaultHeaders);
            console.debug('[Interceptors][KeplerSlapfiveInterceptor] Modified request (unauthed):', clone);
            return next(clone);
        } else {
            // authed endpoint
            const authService = inject(AuthService);
            const clone = cloneAndAddHeaders(req, {
                ...defaultHeaders,
                Authorization: `Bearer ${authService.accessToken}`,
                'csdt-authorization-app': csdtAuthApp,
            });
            console.debug('[Interceptors][KeplerSlapfiveInterceptor] Modified request (authed):', clone);
            return next(clone);
        }
    }

    return next(req);
};
